import { LinkKind } from 'bloko/blocks/link';

export default [
    {
        url: 'https://hh.ru/article/28',
        anchor: 'footer.anonymousLinks.article.28',
        anchorParams: [new Date().getFullYear()],
        kind: LinkKind.Tertiary,
    },
    {
        url: 'https://hh.ru/employer/1455',
        anchor: 'footer.anonymousLinks.employer.hh',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/partners',
        anchor: 'footer.anonymousLinks.partners',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/article/media',
        anchor: 'footer.anonymousLinks.media',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://dev.hh.ru/?utm_source=clickme_hh_ru&utm_medium=main&utm_campaign=niz',
        anchor: 'footer.anonymousLinks.api',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/mobile?from=footer',
        anchor: 'footer.anonymousLinks.mobile',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/forcemobile/?utm_campaign=link&utm_source=clickme.hh.ru',
        anchor: 'footer.anonymousLinks.mobileSite',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/article/176',
        anchor: 'footer.anonymousLinks.article.176',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/article/personal_data',
        anchor: 'footer.anonymousLinks.personalData',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/safety',
        anchor: 'footer.anonymousLinks.safety',
        kind: LinkKind.Secondary,
    },
];
